import { Link as RouterLink } from 'react-router-dom';
// @mui
import { Link, Typography, Stack, Box } from '@mui/material';
// routes
import { PATH_AUTH } from '../../routes/paths';
// layouts
import AuthLayout from '../../layouts/AuthLayout';
// components
import Page from '../../components/Page';
import useAuth from '../../hooks/useAuth';
import AuthSwitcher from '../../components/AuthSwitcher';
// sections
import { LoginForm } from '../../sections/auth/login';
import { APP_NAME } from '../../config';

// ----------------------------------------------------------------------

export default function Login() {
  const { setting } = useAuth();
  const appName = setting?.general?.app_name || APP_NAME;

  return (
    <Page title="Login">
      <AuthLayout title="Hi, Welcome Back">
        <AuthSwitcher />

        <Stack spacing={2} sx={{ mb: 5, textAlign: 'center' }}>
          <Typography variant="h4" sx={{ fontWeight: 'bold' }}>Welcome Back</Typography>
          <Typography sx={{ color: 'text.secondary' }}>Sign in to your account and have a blast!</Typography>
        </Stack>

        <LoginForm />
      </AuthLayout>
    </Page>
  );
}
